import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { ItemFractionalType, ProductType } from "../../contexts/OrderContext";
import {
  calculatePriceFractionalToProduct,
  floatToPrice,
} from "../../functions/price_functions";
import { useOrder } from "../../hooks/useOrder";
import { QuantityButton } from "../QuantityButton";

import "./index.css";
import { useProduct } from "../../hooks/useProduct";

type CartItemProps = {
  product: ProductType;
  reloadProducts: () => Promise<void>;
  showOutStock?: boolean;
  motorTotvs?: boolean;
  typePluginspace?: string;
};

export function CartItem({
  product,
  reloadProducts,
  showOutStock = false,
  motorTotvs = false,
  typePluginspace = "",
}: CartItemProps) {
  const [newQuantity, setNewQuantity] = useState(product.quantity);
  const [removed, setRemoved] = useState(false);
  const { organizeFractions } = useProduct();
  const { changeProduct, removeProduct } = useOrder();

  const [priceAdditionals, setPriceAdditionals] = useState(0);

  const [loadingImage, setLoadingImage] = useState(true);

  useEffect(() => {
    if (product.additionals) {
      let _priceAdditionals = 0;
      product.additionals.map(
        (additional) =>
          (_priceAdditionals += additional.quantity * additional.price)
      );
      setPriceAdditionals(_priceAdditionals);
    }
  }, [product.additionals]);

  function changeQuantity(value: number) {
    if (isNaN(value)) {
      setNewQuantity(1);
      product.quantity = 1;
      changeProduct(product, motorTotvs);
      reloadProducts();
    } else if (value < 1) {
      removeProductCart(product);
      reloadProducts();
    } else if (value <= product.stock || showOutStock) {
      setNewQuantity(value);
      product.quantity = value;
      changeProduct(product, motorTotvs);
      reloadProducts();
    } else {
      Swal.fire({
        icon: "warning",
        title: "Estoque máximo atingido",
        text: "Não será mais possível aumentar a quantidade do produto",
      });
    }
  }

  function removeProductCart(product: ProductType) {
    Swal.fire({
      title: "Remover produto",
      text: "Deseja remover este produto do carrinho?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim!",
    }).then((result) => {
      if (result.isConfirmed) {
        setNewQuantity(0);
        product.quantity = 0;
        removeProduct(product, motorTotvs);
        // window.location.reload();
      } else if (isNaN(product.quantity)) {
        setNewQuantity(1);
        product.quantity = 1;
        changeProduct(product, motorTotvs);
      }
    });
  }

  return product.quantity <= 0 ? (
    <></>
  ) : (
    <div
      className={`cart-product ${product.outStock ? "cart-product-out" : ""}`}
    >
      <div className="product-image">
        {product.image ? (
          <>
            {loadingImage && <div className="no-image-cart" />}
            <img
              style={
                loadingImage
                  ? { visibility: "hidden", width: 0, height: 0 }
                  : {}
              }
              src={product.image}
              alt={product.name}
              onLoad={() => setLoadingImage(false)}
            />
          </>
        ) : (
          <div className="no-image-cart" />
        )}
      </div>
      <div className="cart-product-content">
        <div className="product-title-cart">
          <div className="title">
            <p>
              {product.name.substring(0, 50)}
              {product.name.length > 50 && "..."}
            </p>
          </div>
          <svg
            style={{ cursor: "pointer" }}
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => removeProductCart(product)}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.343227 1.75736L4.58587 6L0.343227 10.2426L1.75744 11.6569L6.00008 7.41421L10.2427 11.6569L11.6569 10.2426L7.41429 6L11.6569 1.75736L10.2427 0.343146L6.00008 4.58579L1.75744 0.343146L0.343227 1.75736Z"
              fill="#ABABAB"
            />
          </svg>
        </div>

        {product.additionals && (
          <div className="product-additionals">
            {product.additionals.map((additional, i) => (
              <p key={`additional-${i}`}>{`${additional.quantity}x ${
                additional.name
              } (${floatToPrice(additional.price)})`}</p>
            ))}
            {product.fractions &&
              organizeFractions(product.fractions).map((fractional, i) => (
                <p key={`fractional-${i}`}>{`${fractional.quantity}/${
                  product.fractions?.length
                } ${fractional.name} (${floatToPrice(fractional.price)})`}</p>
              ))}
          </div>
        )}
        {product.observation && (
          <div className="product-additionals">
            <p>{product.observation}</p>
          </div>
        )}
        <div className="product-specifications">
          {Object.entries(product.variation).map((variation) => {
            if (variation[0] !== "VARIATION" && variation[1] !== "NONE") {
              return (
                <p>
                  {variation[0] === "NOME_COR" ? "COR" : variation[0]}:{" "}
                  <b>{variation[1]}</b>
                </p>
              );
            } else {
              <></>;
            }
          })}
        </div>
        {/* <div className="product-specifications">
          {product?.sku && (
            <p>
              SKU: <b>{product.sku}</b>
            </p>
          )}
        </div> */}
        <div className="product-values-cart">
          <div className="product-quantity-cart">
            <QuantityButton changeValue={() => changeQuantity(newQuantity - 1)}>
              <svg
                width="14"
                height="2"
                viewBox="0 0 14 2"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="14" height="2" fill="#ABABAB" />
              </svg>
            </QuantityButton>
            <input
              type="text"
              onChange={(event) => {
                if (event.target.value !== "") {
                  changeQuantity(parseInt(event.target.value));
                } else {
                  product.quantity = NaN;
                  setNewQuantity(NaN);
                }
              }}
              onBlur={() => {
                if (isNaN(product.quantity)) {
                  removeProductCart(product);
                }
              }}
              value={isNaN(product.quantity) ? "" : product.quantity}
            />
            <QuantityButton changeValue={() => changeQuantity(newQuantity + 1)}>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6 0V6H0V8H6V14H8V8H14V6H8V0H6Z"
                  fill="#ABABAB"
                />
              </svg>
            </QuantityButton>
          </div>
          {product.promotionalPrice === 0 ||
          product.promotionalPrice === product.unitPrice ? (
            <p>
              {product.type === "fractional"
                ? floatToPrice(
                    calculatePriceFractionalToProduct(product) *
                      product.quantity +
                      priceAdditionals * product.quantity
                  )
                : floatToPrice(
                    product.unitPrice * product.quantity +
                      priceAdditionals * product.quantity
                  )}
            </p>
          ) : (
            <div>
              <p className="promotional-price">
                {floatToPrice(product.unitPrice * product.quantity)}
              </p>
              <p>{floatToPrice(product.promotionalPrice * product.quantity)}</p>
            </div>
          )}
        </div>
        {product.outStock && (
          <div className="out-stock-text">
            <svg
              width="15"
              height="13"
              viewBox="0 0 15 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.85352 2.07422L1.43945 10.9609C1.38477 11.043 1.38477 11.0977 1.38477 11.1797C1.38477 11.3984 1.54883 11.5625 1.76758 11.5625H12.3496C12.5684 11.5625 12.7598 11.3984 12.7598 11.1797C12.7598 11.0977 12.7324 11.043 12.6777 10.9609L7.26367 2.07422C7.23633 1.99219 7.1543 1.9375 7.07227 1.9375C6.96289 1.9375 6.9082 1.99219 6.85352 2.07422ZM5.73242 1.39062C6.00586 0.925781 6.52539 0.625 7.07227 0.625C7.5918 0.625 8.11133 0.925781 8.38477 1.39062L13.7988 10.2773C13.9629 10.5508 14.0723 10.8516 14.0723 11.1797C14.0723 12.1094 13.3066 12.875 12.3496 12.875H1.76758C0.837891 12.875 0.0722656 12.1094 0.0722656 11.1797C0.0722656 10.8516 0.154297 10.5508 0.318359 10.2773L5.73242 1.39062ZM7.94727 9.8125C7.94727 10.3047 7.53711 10.6875 7.07227 10.6875C6.58008 10.6875 6.19727 10.3047 6.19727 9.8125C6.19727 9.34766 6.58008 8.9375 7.07227 8.9375C7.53711 8.9375 7.94727 9.34766 7.94727 9.8125ZM7.72852 4.78125V7.40625C7.72852 7.78906 7.42773 8.0625 7.07227 8.0625C6.68945 8.0625 6.41602 7.78906 6.41602 7.40625V4.78125C6.41602 4.42578 6.68945 4.125 7.07227 4.125C7.42773 4.125 7.72852 4.42578 7.72852 4.78125Z"
                fill="#EB5353"
              />
            </svg>
            <p>Fora de estoque</p>
          </div>
        )}
      </div>
    </div>
  );
}
